import{_ as f}from"./_deburrLetter.js";import{t as r}from"./toString.js";var e=f,u=r,t=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,x=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),o=function(f){return(f=u(f))&&f.replace(t,e).replace(x,"")};export{o as d};
//# sourceMappingURL=deburr.js.map
